module.exports = __webpack_public_path__ + "static/img/joystick_move.881a8855.png";